import React from "react";

const Blockquote = ({ customComponent, onChange, isActive, isDisabled }) => {
	const toggleBlockquote = () => {
		if (onChange) onChange();
	};

	return (
		<>
			<button
				className={`editor-menu-item${isActive ? " is-active" : ""}`}
				onClick={toggleBlockquote}
				title="Block Quote"
				type="button"
				disabled={isDisabled}>
				{customComponent ? (
					customComponent
				) : (
					<i className="fas fa-quote-left" />
				)}
			</button>
		</>
	);
};

export default Blockquote;
